import { render, staticRenderFns } from "./account-setting.vue?vue&type=template&id=8008d730&scoped=true"
import script from "./account-setting.vue?vue&type=script&lang=ts"
export * from "./account-setting.vue?vue&type=script&lang=ts"
import style0 from "./account-setting.vue?vue&type=style&index=0&id=8008d730&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8008d730",
  null
  
)

export default component.exports